import React, {useMemo, useState} from 'react';

import {Button, Grid, Icon} from '@material-ui/core';
import {Card, Form, Col, InputGroup} from 'react-bootstrap';
import {useSamplesUIContext} from "../../../contexts/SamplesUIContext";
import {sampleReqStatus} from "../SamplesTable/ui.helpers";
import {format} from "date-fns";

const toDay = format(new Date(), 'yyyy-MM-dd');

export function SamplesFilter() {
  const context = useSamplesUIContext();

  const {queryParams, setQueryParams} = useMemo(() => ({
    queryParams: context.queryParams,
    setQueryParams: context.setQueryParams,
  }), [context]);

  const [filter, setFilter] = useState(queryParams.filter);

  const handleChangeFilter = key => e => {
    setFilter({...filter, [key]: e.target.value});
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const _filter = {
      ...filter,
      startDt: filter.startDt ? format(new Date(filter.startDt), 'yyyyMMdd') : '',
      endDt: filter.endDt ? format(new Date(filter.endDt), 'yyyyMMdd') : '',
    }
    setQueryParams({...queryParams, filter: _filter});
  };

  return (
    <Form onSubmit={handleSubmit}>
      <Card>
        <Card.Body>
          <Card.Title as="h5" className="mb-5">
            <Icon color="secondary" className="mr-2 align-middle">search</Icon>
            검색
          </Card.Title>
          <hr className="mb-10" />

          <Grid container>
            <Grid item xs={6} md={3}>
              <Form.Group as={Col} controlId="goodsNo">
                <Form.Label>상품 코드</Form.Label>
                <Form.Control
                  type="text"
                  placeholder="상품코드를 입력하세요."
                  value={filter.goodsNo}
                  onChange={handleChangeFilter('goodsNo')}
                />
              </Form.Group>
            </Grid>

            <Grid item xs={6} md={3}>
              <Form.Group as={Col} controlId="goodsNm">
                <Form.Label>상품명</Form.Label>
                <Form.Control
                  type="text"
                  placeholder="상품명을 입력하세요."
                  value={filter.goodsNm}
                  onChange={handleChangeFilter('goodsNm')}
                />
              </Form.Group>
            </Grid>

            <Grid item xs={6} md={3}>
              <Form.Group as={Col} controlId="rplySttsCd">
                <Form.Label>처리 상태</Form.Label>
                <Form.Control
                  as="select"
                  value={filter.rplySttsCd}
                  onChange={handleChangeFilter('rplySttsCd')}
                >
                  <option value="">전체</option>
                  {sampleReqStatus.map(opt => (
                    <option key={opt.key} value={opt.key}>{opt.label}</option>
                  ))}
                </Form.Control>
              </Form.Group>
            </Grid>

            <Grid item xs={12} md={6}>
              <Form.Group as={Col}>
                <Form.Label>샘플 신청 일자</Form.Label>
                <InputGroup>
                  <Form.Control
                    id="startDt"
                    type="date"
                    max={filter.endDt}
                    value={filter.startDt}
                    placeholder="yyyy. mm. dd"
                    aria-describedby="basic-addon1"
                    onChange={handleChangeFilter('startDt')}
                  />
                  <InputGroup.Prepend>
                    <InputGroup.Text>~</InputGroup.Text>
                  </InputGroup.Prepend>
                  <Form.Control
                    id="endDt"
                    type="date"
                    min={filter.startDt}
                    max={toDay}
                    value={filter.endDt}
                    placeholder="yyyy. mm. dd"
                    aria-describedby="basic-addon2"
                    onChange={handleChangeFilter('endDt')}
                  />
                </InputGroup>
              </Form.Group>
            </Grid>

            <Grid item xs={12} className="text-right pl-3 pr-3">
              <Button
                type="submit"
                variant="contained"
                color="secondary"
                size="large"
                className="w-130px"
              >
                검색
              </Button>
            </Grid>
          </Grid>
        </Card.Body>
      </Card>
    </Form>
  );
}
